import { singleton } from "aurelia-framework";

declare global
{
	interface Window
	{
		dataLayer: any[];
	}
}

/**
 * Helper service that pushes custom events to the Google Tag Manager `dataLayer`.
 */
@singleton()
export class GoogleTagManagerService
{
	public pushEvent(event: string, data?: Record<string, string | number | boolean>): void
	{
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({ event, ...data });
	}
}
